import React from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  setAuthToken,
  checkCookieForAuthToken,
  fetchActiveUserIfNeeded,
} from 'Store/users/actions';
import {
  initializeAmplitudeForWeb,
  setAmplitudeUserForWeb,
} from 'Store/stats/actions';
import * as reducers from 'Store/reducers';

import GamePlayer from 'Containers/GamePlayer';

class ModelEmbedder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      requestedActiveUser: false,
      sentAmplitudeRequest: false,
    };
  }

  componentDidMount() {
    const { location, checkCookieForAuthToken } = this.props;
    const { token } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    if (token) {
      this.props.setAuthToken(token);
    } else {
      checkCookieForAuthToken();
      this.props.initializeAmplitudeForWeb();
    }
  }

  componentDidUpdate(prevProps) {
    // When we add a new page to the history, scroll to the top.
    const { authToken, activeUser } = this.props;

    // If there is no active user in the store, fetch it.
    if (authToken && !this.state.requestedActiveUser) {
      this.setState({ requestedActiveUser: true }, () =>
        this.props.fetchActiveUserIfNeeded()
      );
    }

    // If we have a user, set their amplitude user context.
    if (activeUser && !this.state.sentAmplitudeRequest) {
      this.setState({ sentAmplitudeRequest: true }, () =>
        this.props.setAmplitudeUserForWeb()
      );
    }
  }

  render() {
    const { gameSlug } = this.props;
    return <GamePlayer gameSlug={gameSlug} />;
  }
}

const mapStateToProps = state => {
  return {
    authToken: reducers.getAuthToken(state),
    isFetchingActiveUser: reducers.getIsFetchingActiveUser(state),
    activeUser: reducers.getActiveUser(state),
  };
};

export default withRouter(
  connect(mapStateToProps, {
    setAuthToken,
    checkCookieForAuthToken,
    fetchActiveUserIfNeeded,
    initializeAmplitudeForWeb,
    setAmplitudeUserForWeb,
  })(ModelEmbedder)
);
